import { render, staticRenderFns } from "./ListeningPhonics1.vue?vue&type=template&id=55a57b6a&scoped=true&"
import script from "./ListeningPhonics1.vue?vue&type=script&lang=js&"
export * from "./ListeningPhonics1.vue?vue&type=script&lang=js&"
import style0 from "./ListeningPhonics1.vue?vue&type=style&index=0&id=55a57b6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a57b6a",
  null
  
)

export default component.exports